import React, { useMemo, useState } from "react";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import { isLiveStatus, isStartListStatus } from "helpers/status";
import Status from "components/presentation/Status";
import NotAvailable from "components/common/NotAvailable";
import { ProgressBarTRI as ProgressBar } from 'components/general/ProgressBar';
import LiveCheckBox from "components/general/LiveCheckbox";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//Race Block Start
//Races Block Relay 

//Races Without Block start and 800 no Road Races

//Road races
import ColumnsRaceAnalysis from 'components/sports/ath/race_road/results/ColumnsRaceAnalisis'
import ColumnsRaceAnalysisLive from 'components/sports/ath/race_road/results/ColumnsRaceAnalisisLive'

//Vertical Jumps

//Horizontal Jumps

//Throws

//Decathlon,Heptathon

import { CATEGORY, getIsEvent800m, getIsEventRoad, getIsEventRelay, getIsEventCombined } from 'components/sports/ath/helper/AthHelpers'

//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'




const getConfiguration = (data, rsc, resStatus) => {
    const type = findArray(data?.config?.extendedConfig, { code: ['CATEGORY'] }).value
    const isStartingLine = findArray(data?.config?.extendedConfig, { code: ['START_IN_LANES'] }).value === 'Y' ? true : false
    const isEvent800 = getIsEvent800m(rsc);
    const isEventRoad = getIsEventRoad(rsc);
    const isEventRelay = getIsEventRelay(rsc);
    const columnsAdded = data?.results?.extendedInfos ? data.results.extendedInfos.sort((a, b) => a.ei_pos - b.ei_pos) : []
    const isStartList = isStartListStatus(resStatus)
    const isLive = isLiveStatus(resStatus);
    const scheduleStatus = data?.results?.schedule?.status.code;

    let configuration = {
        columns: [],
        subComponent: null,
        caption: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            category: type,
            isStartingLine: isStartingLine,
            isEvent800: isEvent800,
            isEventRoad: isEventRoad,
            isEventRelay: isEventRelay,
            columnsAdded: columnsAdded,
        }
    };



    configuration.caption = <CaptionTable
        leftCol={data && data.results.eventUnit.description}
        //centerCol={<span className="text-dark">{resultStatus}</span>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resStatus} />}
    />

    configuration.sortBy = isStartList
        ? [{ id: 'StartOrder', desc: false }]
        : isLive?[{ id: 'RankIntermediate', desc: false }]:[{ id: 'Rank', desc: false }]

    switch (type) {
        case CATEGORY.RACE: //Races
            configuration.filters = {
                ei_type: ['DISPLAY'],
                ei_code: ['INTERMEDIATE_CURRENT']
            };

            if (isEventRoad) { //Road

                configuration.columns = isLive ? ColumnsRaceAnalysisLive(columnsAdded) : ColumnsRaceAnalysis(columnsAdded)

            }
            break;

        default:
            configuration.columns = []
    }

    return configuration;
};


const getProgessBarConfiguration = () => {
    let config = {
        distance: {
            unit: 'km'
        }
    }

    config.distance.unit = 'km'
    config.numColVisibles = { sm: 1, lg: 4 }

    let _breakpoints = config.breakpoints || {
        0: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
        1024: { slidesPerView: 6 },
    }


    return config;
}

const AthAnalysis = ({ data }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status.code;
    const progressBarConfig = getProgessBarConfiguration();

    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus), [resultStatus, mirs_rsc]);

    const filtersFinalSplit = {
        ei_type: ['UI'],
        ei_code: ['INTERMEDIATES_TOTAL']
    };

    const filtersCurrentCompetitor = {
        ei_type: ['DISPLAY'],
        ei_code: ['CURRENT']
    };

    let extendedInfos = data?.results?.extendedInfos
    let finalSplit = extendedInfos && findArray(extendedInfos, filtersFinalSplit).ei_value;
    let currentSplit = extendedInfos && findArray(extendedInfos, configEvent.filters).ei_value;
    let currentCompetitor = extendedInfos && findArray(extendedInfos, filtersCurrentCompetitor).ei_value


    currentSplit = (currentSplit === 'F') ? finalSplit : currentSplit // ponemos un numero muy alto prar que internamente se posicione en el ultimo 
    currentSplit = (currentSplit === undefined) ? 1 : currentSplit
    //numero de splits visibles 
    const extendedColsVisibles = 3

    return (
        <>
            {data?.results ? (
                <>

                    <ProgressBar id={`mirs-progressbar-${mirs_rsc}`} data={data?.progressBar} config={progressBarConfig} dinamic={true} />
                    <LiveCheckBox id={`mirs-livecheckbox-${mirs_rsc}`} />

                    {data?.results?.items ? (
                        < MirsTable
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Splits to show
                            colsExtendedVisible={extendedColsVisibles}
                            //current split (initial)
                            colIndex={parseInt(currentSplit) <= extendedColsVisibles ? extendedColsVisibles : parseInt(currentSplit)} //Columna Posicionada con splits
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            // hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            //Indicate if has related timeline                            
                            hasRelatedTimeline={true}

                            //Show buttons move to splits 
                            showNavExtendedData={false}
                            //add current class to current competitor
                            getRowProps={row => ({
                                className: row.original.participant.code === currentCompetitor ? 'currentIndicator' : '',

                            })}
                        /*
                            getHeaderProps={column => ({})}
                            getColumnProps={column => ({onClick: () => alert('Column!'),})}
                            getCellProps={cellInfo => ({
                                style: {
                                    // backgroundColor: 'red',
                                },
                            })}
                        
                        */

                        />
                    ) : ('')
                    }

                </>
            ) : (
                <NotAvailable />
            )
            }
        </>
    );
};

export default AthAnalysis;
